import React from 'react';
import {Divider as MuiDivider} from '@material-ui/core';

export default function Divider({
    className,
    ...restProps
}) {
    return (
        <MuiDivider
            fullwidth="true"
            {...restProps}
        />
    )
}



// WEBPACK FOOTER //
// ./src/components/controls/Divider.jsx